import {Injectable} from '@angular/core';
import {DataService} from '../data.service';
import {Observable, catchError} from 'rxjs';
import {RateTypesSro, RatesSroMaster} from 'src/app/shared/common-components/common-structure';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RateTypesSroService extends DataService {

  private baseURI = this.apiUri + '/ratetypessro/';
  private baseNewURI = this.apiUri + '/ratetypessro/';
  public observable$: any;

  constructor(http: HttpClient) {
    super(http);
  }

  getSroIdListByRateTypeId(rateTypeId: number): Observable<any> {
    return this.http.get(this.baseURI + rateTypeId + '/rateTypeId');
  }

  /*  getSroListByRateTypeIdByBidCycle(rateTypeId: number, bidCycleId: number): Observable<any> {
      const URI = '/tmssserver/api/public';
      return this.http.get(URI + `/ratetypessro/${rateTypeId}/ratetypeid`);
    }*/

  getSroListByRateTypeIdByBidCycle(rateTypeId, bidCycleId, carrierId): Observable<RatesSroMaster[]> {
    // http://localhost:8380/tmssserver/api/public/ratesbidcycles/getSrosForRateBidcyclesFRT/22/ratesBidcyclesId/5/carrierId/18/rateTypeId
    this.setUri(this.apiUri + `/ratesbidcycles/getSrosForRateBidcyclesFRT/${bidCycleId}/ratesBidcyclesId/${carrierId}/carrierId/${rateTypeId}/rateTypeId`);
    return this.get().pipe(catchError(this.handleError));
  }

  getAllRateTypeSrosByBidDate(beginDate: Date, endDate: Date): Observable<any> {
    return this.http.get(this.baseNewURI + 'ratetypessrolist/' +
      beginDate + '/beginDate/' +
      endDate + '/endDate');
  }

  getAllSros(): Observable<any> {
    return this.http.get(this.baseNewURI + 'ratetypessrolist/frt');
  }

  getHhgAll(): Observable<any> {
    return this.http.get(this.baseNewURI + 'ratetypessrolist/hhg');
  }

  getHhgRateTypeSrosByBidDate(beginDate: Date, endDate: Date): Observable<any> {
    return this.http.get(this.baseNewURI + 'ratetypessrolist/hhg/' +
      beginDate + '/beginDate/' +
      endDate + '/endDate');
  }
}
